import React from 'react';
import StressTestBreakdownTimeSeries from './StressTestBreakdownLineChart.component';
import useFetchData from '../../../../../hooks/useFetchData';
import GeneralComponentErrorShield from '../../../../general/GeneralComponentErrorShield';

interface DetailProps {
  dataKey: string;
  fundId: string;
  positionDate?: string;
}

const Detail: React.FC<DetailProps> = ({ dataKey, fundId, positionDate }) => {
  const breakdownData = useFetchData({
    url: `get_private_equity_stress_test_breakdown/${fundId}/${positionDate}/${dataKey}`,
    keyName: `stress_test_breakdown_data_${fundId}_${dataKey}_${positionDate}`,
    makeFetch: positionDate ? true : false,
  });

  return (
    <GeneralComponentErrorShield
      dataObjects={[breakdownData]}
      customLoadingMessages={['Loading Historical Timeseries Data...']}
      customErrorMessage={'No Data Found'}
    >
      <StressTestBreakdownTimeSeries data={breakdownData} dataKey={dataKey} />
    </GeneralComponentErrorShield>
  );
};

export default Detail;
